export default "__VITE_ASSET__60bea9b2__"